module.exports = __webpack_public_path__ + "static/media/galerija_2021 (29)-min.8e5b341f.jpg";